import {IValidator} from "../interface";

const password = (data: IValidator) => {
    const {value, t} = data;
    if(value && (value as string).length < 8) {
        return Promise.reject(t("formError:password"));
    }
    else if (value && !/[0-9]/.test(value as string)){
        return Promise.reject(t("formError:password"));
    }
    else if (value && !/[A-Z,А-Я]/.test(value as string)){
        return Promise.reject(t("formError:password"));
    }
    else if (value && !/[a-z,а-я]/.test(value as string)) {
        return Promise.reject(t("formError:password"));
    }

    return Promise.resolve()
}

export default password
